'use client';

import { useEffect } from 'react';
import { ThemeProvider } from '@/components/marketing/engine/theme-context';

export function MarketingShell({ children }: { children: React.ReactNode }) {
  useEffect(() => {
    document.body.setAttribute('data-marketing', '');
    return () => document.body.removeAttribute('data-marketing');
  }, []);

  return <ThemeProvider>{children}</ThemeProvider>;
}
